import axios from '@axios'

export default {
    namespaced: true,
    state: {
        empresas: [],
        empresasAll: [],
    },
    getters: {
        getEmpresas(state) {
            return state.empresas
        },
        getEmpresasAll(state) {
            return state.empresasAll
        }
    },
    mutations: {
        setEmpresas(state, empresas) {
            state.empresas = empresas
        },
        setEmpresasAll(state, empresasAll) {
            state.empresasAll = empresasAll
        },
    },
    actions: {
        fetchEmpresas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/empresas', { params: data })
                    .then((response) => {
                        commit('setEmpresas', response.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error)
                    })
            })
        },
        fetchEmpresasAll({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.get('/api/auth/empresas/all', { params: data })
                    .then((response) => {
                        commit('setEmpresasAll', response.data.data)
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error)
                    })
            })
        },
        setEmpresa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/empresas/setEmpresa', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error)
                    })
            })
        },
        enviarEmpresa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/auth/empresas', data)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error)
                    })
            })
        },
    },
}